import { ChatChannelType } from 'src/@types/chat';
import { useChatChannelsOfType } from './useChatChannelsOfType';

export const useDirectMessagesChatChannels = ({
  includeHidden = false,
}: {
  includeHidden?: boolean;
}) => {
  return useChatChannelsOfType({
    type: ChatChannelType.TEXT,
    p2p: true,
    includeHidden,
  });
};
